import { IRemotesArea } from '../types/remote-area'
import useAxios from './useAxios'

export const useRemoteArea = () => {
  const { data, isLoading } = useAxios<IRemotesArea>({
    url: `/remote-area/flash`,
  })

  return {
    loading: isLoading,
    data,
  }
}
